<script lang="ts">
    import { _ } from 'svelte-i18n';

    import SearchInput from '../../shared/SearchInput.svelte';
    import { filterVehiclesQuery } from './FilterVehiclesStore';
</script>

<div class="filter">
    <SearchInput
        placeholder={$_('Search by name')}
        query={$filterVehiclesQuery}
        onChange={() => {}}
        onKeyup={query => {
            $filterVehiclesQuery = query;
        }}
    />
    <!--    <Checkbox checked={$filter.vehicles.onlyEnabled} label="Only enabled" onChange={()=>{$filter.vehicles.onlyEnabled=!$filter.vehicles.onlyEnabled}} />-->
</div>

<style>
    .filter {
        display: flex;
        flex-direction: row;
        align-items: center;
        /*padding: 0 1rem;*/
        padding: 2px 0;
        border: 1px solid var(--color-gray-300);
        border-radius: 0.5rem;
        column-gap: 10px;
    }
</style>
